import { Injectable } from "@angular/core";
import { NgbDatepickerI18n, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

const I18N_VALUES = {
  es: {
    weekdays: ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
    months: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ],
    dayNames: [
      "Lunes",
      "Martes",
      "MiÃ©rcoles",
      "Jueves",
      "Viernes",
      "SÃ¡bado",
      "Domingo"
    ],
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ]
  }
};

@Injectable({
  providedIn: "root"
})
export class I18nEs {
  language = "es";
}

// Define custom service providing the months and weekdays translations
@Injectable({
  providedIn: "root"
})
export class DatepickerI18nService extends NgbDatepickerI18n {
  constructor(private _i18n: I18nEs) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }

  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }

  getMonthFullName(month: number): string {
    return I18N_VALUES[this._i18n.language].monthNames[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}/${date.month}/${date.year}`;
  }
}
